import React, { createContext, useContext, useEffect, useState } from "react";
import { getCookie } from "./webStorage.js";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [storeData, setStoreData] = useState("");
  const [openProfile, setCloseProfile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPersonalize, setIsPersonalize] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [currentModule, setCurrentModule] = useState("sales");
  const [showInternetStatus, setShowInternetStatus] = useState(false);

  const token = getCookie("scspt");

  const setUser = (user) => {
    setUserData(user);
    console.log("✅ Setting User:", user);
    if (user?.permissions) {
      console.log("🔄 Updating Permissions:", user.permissions);
      setPermissions(user.permissions);
    } else {
      console.log("⚠️ No permissions found, setting empty array");
      setPermissions([]);
    }
  };

  // Update permissions when userData changes
  useEffect(() => {
    if (userData?.permissions) {
      setPermissions(userData.permissions);
    } else {
      setPermissions([]);
    }
  }, [userData]);

  // Online/offline listener
  useEffect(() => {
    const handleOnline = () => setShowInternetStatus(false);
    const handleOffline = () => setShowInternetStatus(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) setShowInternetStatus(true);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        token,
        userData,
        setUser,
        storeData,
        setStoreData,
        openProfile,
        setCloseProfile,
        isMenuOpen,
        setIsMenuOpen,
        permissions,
        setPermissions,
        showInternetStatus,
        isPersonalize,
        setIsPersonalize,
        showSearch,
        setShowSearch,
        currentModule,
        setCurrentModule,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);